import React, { useEffect, useState } from 'react'
import { Button, Col, Row, message } from 'antd'
import PopupCreate from '../components/admin/PopupCreate'
import PopupUpdate from '../components/admin/PopupUpdate'
import { fetchAPI } from '../utils/use.api'
import { loginWithGoogle } from '../utils/firebase/login'
import TableAdmin from '../components/admin/Table'

export default function Admin() {
    return (
        <>
            <div
                style={{
                    backgroundColor: 'white',
                    height: '100vh',
                    width: '100vw',
                    position: 'fixed'
                    // zIndex: -1,
                }}
            />
            {localStorage.getItem('token') ? <Dashboard /> : <Login />}
        </>
    )
}

function Login() {
    useEffect(() => {
        localStorage.removeItem('token')
    })

    async function handleLogin() {
        var token = (await loginWithGoogle()) as any
        fetchAPI({
            method: 'POST',
            uri: '/auth/verify',
            Headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                tokenFirebase: token.user.accessToken
            })
        }).then((res) => {
            if (res?.token) {
                localStorage.setItem('token', res.token)
                window.location.reload()
            } else {
                message.error('Đăng nhập thất bại')
            }
        })
    }

    return (
        <div>
            <Button onClick={handleLogin}>Đăng nhập</Button>
        </div>
    )
}

function Dashboard() {
    const [data, setData] = React.useState([])
    const [selectedRowKey, setSelectedRowKey] = useState(null)

    useEffect(() => {
        fetchNewData()
    }, [])

    // useEffect(() => {
    //   console.log(selectedRowKey);
    // }, [selectedRowKey]);

    function fetchNewData() {
        fetchAPI({
            method: 'GET',
            uri: '/posts'
        }).then((res) => {
            setData(res)
        })
    }

    function handleLogout() {
        localStorage.removeItem('token')
        window.location.reload()
    }

    return (
        <div style={{ zIndex: 999, padding: '5rem' }}>
            <Row justify={'space-between'}>
                <Col>
                    <Button onClick={handleLogout}>Đăng xuất</Button>
                </Col>
                <Col>
                    <Row gutter={[10, 10]}>
                        <Col>
                            <PopupCreate fetchNewData={fetchNewData} setSelectedRowKey={setSelectedRowKey} />
                        </Col>
                        <Col>
                            {selectedRowKey ? (
                                <PopupUpdate fetchNewData={fetchNewData} selectedRowKey={selectedRowKey} setSelectedRowKey={setSelectedRowKey} />
                            ) : (
                                <Button disabled>Cập nhật</Button>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <br />
            <TableAdmin data={data} selectedRowKey={selectedRowKey} setSelectedRowKey={setSelectedRowKey} fetchNewData={fetchNewData} />
        </div>
    )
}
